import angular from 'angular';
import {SummaryViewComponent} from './summary-view.component';

export const summaryViewModule = angular.module('slviz.summaryView', [])
    .component('summaryView', SummaryViewComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/views/summary-view/index.js